import { Meta } from "../redux/types";

export const defaultMeta: Meta = {
  current_page: 0,
  from: 0,
  last_page: 0,
  per_page: 0, 
  to: 0,
  total: 0,
}